import { render } from "./LeaveAssign.vue?vue&type=template&id=c90cb840"
import script from "./LeaveAssign.vue?vue&type=script&lang=js"
export * from "./LeaveAssign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__